// extracted by mini-css-extract-plugin
export default {"page":"mX-z","cartModal":"nX-z","checkout":"oX-z","placeholder":"pX-z","account":"qX-z"};